import { Button, Heading, Modal, Text, VStack } from 'native-base'

import WarningTriangleSVG from '../../../assets/WarningTriangleSVG'
import { AddInstructionsLaterButton } from '../Common/AddInstructionsLaterButton'
import { ICloseModalOptions } from '../InstructionsModal'

export interface ErrorModalContentProps {
  onSubmit: () => void
  closeModal: ({ clearAddressFields, clearGeocode, showToast, toastProps }: ICloseModalOptions) => void
}

export const ErrorModalContent = ({ onSubmit, closeModal }: ErrorModalContentProps) => {
  return (
    <Modal.Content
      justifyContent={'center'}
      alignItems={'stretch'}
      overflowY={'auto'}
      bg={'brand.warmWhite'}
      width={350}
      maxWidth={'90svw'}
      height={550}
      maxHeight={'95svh'}
    >
      <VStack space={4} p={3} my={4}>
        <Heading textAlign={'center'} size={'md'} fontWeight={500}>
          Issue Submitting Instructions
        </Heading>
        <VStack space={1} alignItems={'center'} w={'100%'}>
          <WarningTriangleSVG />
          <Heading textAlign={'center'} size={'sm'} fontWeight={500}>
            An error occurred while submitting your instructions
          </Heading>
          <Text textAlign={'center'} fontSize={14} color={'brand.softBlack'}>
            Please try again later.
          </Text>
        </VStack>
        <VStack space={1} alignItems={'center'} w={'100%'}>
          <Button onPress={onSubmit} _focusVisible={{ outlineStyle: 'none' }}>
            Enter New Phone Number
          </Button>
          <AddInstructionsLaterButton closeModal={closeModal} />
        </VStack>
      </VStack>
    </Modal.Content>
  )
}
